import React from "react";
import { onKeyDown } from "../../service";
import classes from "./CheckBox.module.css";

const CheckBox = ({ checked, onChecked, onRemoveChecked, children, value }) => {
    
    const handleChange = (e) => {
        e.target.checked ?
            onChecked(value) :
            onRemoveChecked(value)
    }

    return (<div className={classes.CheckBox}>
        <input
            type={"checkbox"}
            checked={!!checked}
            name={value}
            onChange={handleChange}
            onKeyDown={e => onKeyDown(e, () => handleChange({ target: { checked: !checked } }))}
            className={`${classes.CheckBoxInput} ${checked && classes.Checked}`} >
        </input>
        <div className={classes.Text}>{children}</div>
    </div>)
}
export default CheckBox;